import { Injectable } from '@angular/core';
import {
  ExternalpageService,
  externalpageTypes,
  externalpageImageTypes,
  externalpageStatuses
} from './externalpage.service';
import {Subject} from 'rxjs';
import {DomainService} from './domain.service';


@Injectable({
  providedIn: 'root'
})
export class ProjectService {

  externalpageTypes = externalpageTypes;
  externalpageImageTypes = externalpageImageTypes;

  public homeData: any[] = [];
  public $homeDataSubject: Subject<any> = new Subject();


  /**
   * Constructor
   *
   * @param externalpageService
   */
  constructor(
    private externalpageService: ExternalpageService,
    private domain: DomainService
  ) {

  }

  /**
   * Get home data
   */
  getHomeData() {

    return this.homeData;

  }

  /**
   * Set home data
   */
  setHomeData() {
    if (this.homeData.length == 0) {

      const $queryParams = {
        pageNumber: 1,
        pageSize: 12,
        PageStatus: externalpageStatuses.Published
      };

      this.externalpageService.apiGetExternalPageType(this.externalpageTypes.Project, $queryParams, this.domain.getCurrentRegion()).subscribe( (result: any) => {
        if (result && result.hasOwnProperty('data')) {
          this.homeData = Object.assign([], result.data);

          if (this.homeData.length > 0) {

            // Get all images of projects
            for (const i in this.homeData) {
              this.homeData[i]['imageUri'] = '';

              if (this.homeData[i]['imageReferences']?.length > 0) {
                for (const image of this.homeData[i]['imageReferences']) {
                  if (image['imageType'] == this.externalpageImageTypes.MainImage) {
                    this.homeData[i]['imageUri'] = image['imageUri'];
                  }
                }
              }
            }

            this.$homeDataSubject.next(true);

          } else {
            this.$homeDataSubject.next(true);
          }
        }
      });
    }
  }

}
